import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import Spline from "@splinetool/react-spline";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row className="justify-content-center">
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Greetings!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👽
                </span>
              </h1>

              <h1 className="heading-name">
                I'm
                <strong className="main-name"> a!3x b01duc</strong>
              </h1>

              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
              </div>
            </Col>
            <Col md={5} className="d-flex justify-content-center">
              <div
                style={{
                  position: "relative",
                }}
              >
                <Spline
                  scene="https://prod.spline.design/EQvuHNW81LG4WgWS/scene.splinecode"
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
